$(function() {
    var ddlCountry = $("#form-enquiry #Country");
    setRegionList(ddlCountry);

    $("#form-enquiry select").on("change",
        function() {
            if ($(this).val() === "") {
                var err = $(this).data("fv-notempty-message");
                
                var parent = $(this).closest(".form-group");
                parent.addClass("has-error");
                if (parent.has(".help-block").size() === 0) {
                    parent.append("<small class='help-block'>" + err + "</small>");
                } else {
                    parent.find(".help-block").show();
                }
            }
        });
});

function enquirySuccesfullSubmitted() {
    $(".form-group").hide();
}

function setRegionList(country) {

    $("#form-enquiry #City").hide();
    $("#form-enquiry #CityNZ").hide();
    $("#form-enquiry #State").hide();
    $("#form-enquiry #City").removeAttr("required");
    $("#form-enquiry #CityNZ").removeAttr("required");
    $("#form-enquiry #State").removeAttr("required");
    $(".city-based-address").hide();
    $(".state-based-address").hide();
    
    if (country.val() === "Australia") {
        $(".state-based-address").show();
        $("#form-enquiry #State").show();
        $("#form-enquiry #State").attr("required", "required");

    } else if (country.val() === "New Zealand") {
        $(".city-based-address").show();
        $("#form-enquiry #CityNZ").show();
        $("#form-enquiry #CityNZ").attr("required", "required");
    } else {
        $(".city-based-address").show();
        $("#form-enquiry #City").show();
        $("#form-enquiry #City").attr("required", "required");
    }		
}